import { z } from 'zod';
import { isScheduledTimeValid } from '../logic/timeValidation.logic';
import { format } from 'date-fns';
import { DATE_FORMATS } from '@/lib';

export const createEditFlowSchema = (isDateTrigger: boolean) =>
    z
        .object({
            flowName: z.string().trim().min(1, 'Flow name is required'),
            selectedProducts: isDateTrigger
                ? z.array(z.number()).optional()
                : z.array(z.number()).min(1, 'At least one product is required'),
            selectedExcludeProducts: z.array(z.number()).optional(),
            showRemoveRecipients: z.boolean().optional(),
            selectedDate: z.date().optional(),
            selectedTime: z.number().optional(),
            selectedTimezone: z.string().optional(),
        })
        .refine(
            data => {
                // Only validate time for date trigger flows
                if (!isDateTrigger) {
                    return true;
                }

                // Skip validation if required fields are missing
                if (!data.selectedDate || data.selectedTime === undefined) {
                    return true;
                }

                // Convert Date to ISO string for validation
                const dateString = format(data.selectedDate, DATE_FORMATS.ISO_8601);
                const validation = isScheduledTimeValid(dateString, data.selectedTime, data.selectedTimezone);
                return validation.isValid;
            },
            data => {
                if (isDateTrigger && data.selectedDate && data.selectedTime !== undefined) {
                    const dateString = format(data.selectedDate, DATE_FORMATS.ISO_8601);
                    const validation = isScheduledTimeValid(dateString, data.selectedTime, data.selectedTimezone);
                    return {
                        message:
                            validation.error || 'Please schedule the broadcast for at least 10 minutes in the future.',
                        path: ['selectedTime'],
                    };
                }
                return {
                    message: 'Please schedule the broadcast for at least 10 minutes in the future.',
                    path: ['selectedTime'],
                };
            }
        );

export type EditFlowFormData = z.infer<ReturnType<typeof createEditFlowSchema>>;
